import { Component, Inject, OnInit } from '@angular/core';
import { projectActions } from '@src/store/reducers/projectReducer';
import { Store } from '@src/store';
import { cloneDeep } from 'lodash';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { DialogManagerService } from '@src/services';
import { StringFormatPipe } from '@app/shared/pipes/stringFormat.pipe';
import { IVariables } from '@src/interfaces/variables.interfaces';
import { projectsActions } from '@src/store/reducers/projectsReducer';

@Component({
    selector: 'variables',
    template: require('./variables.component.html'),
    styles: [require('./variables.component.scss')]
})
export class VariablesComponent implements OnInit {
    private readonly projectId: number;
    public displayedColumns: any;
    public dataSource: any = [];
    public tmpDataSource: any;
    public translations;
    private environments: any = [];
    private projectEnvTypes: any;
    public validationSave: string[] = [];
    public isValid: boolean = true;
    private envsName: string = '';
    public userVariables: IVariables[] = [];
    private tmpUserVariables: IVariables[] = [];
    public projectData:any;
    constructor(private store: Store,
                @Inject('$state') private state: any,
                private translatePipe: TranslatePipe,
                private stringFormatPipe: StringFormatPipe,
                private dialogManagerService: DialogManagerService) {
        this.projectId = this.state.params.id;
    }

    public async ngOnInit() {
        this.projectData = await this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA,
            payload: { projId: this.projectId } });
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']).then(value => this.translations = value);
        const apiRequests = async (action: any) => await this.store.dispatch(
            { type: action, payload: { projId: this.projectId } });
        const res = await apiRequests(projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS);
        this.displayedColumns = [
            { name: 'Variable Name', type: 'Textbox' },
            { name: 'Default Value', type: 'Textbox' }];
        if(this.projectData?.data?.options?.AutoGenerateDryRun == true){
            this.displayedColumns.push({name: 'DryRun', type: 'Textbox'})
        }
        if (res.data) {
            this.projectEnvTypes = res.data;
            this.projectEnvTypes.forEach((envType) => {
                const newEnvsType = envType.environments.map((item) => {
                    return {
                        id: item.id,
                        isRMSource:envType.isRMSource,
                        name: item.name,
                        camelCaseName: this.stringFormatPipe.transformStr(item.name)
                    };
                });
                this.environments = [...this.environments, ...newEnvsType];
            });
            this.environments.forEach(env => this.displayedColumns.push({ name: env.name, type: 'Textbox' }));
            this.getUserVariables();
        }
        this.environments.forEach((env: any, idx, array) => {
            this.envsName += (idx === array.length - 1) ? env.name : env.name + ' and ';
        });
    }
    private getUserVariables(): void {
        this.store.dispatch({ type: projectActions.GET_USER_DEFINED, payload: { projectId: this.projectId } })
            .then((variables: any) => {
                if (variables) {
                    this.userVariables = variables;
                    this.tmpUserVariables = cloneDeep(this.userVariables);
                    this.mapVariablesToDataSource(variables);
                    this.tmpDataSource = cloneDeep(this.dataSource);
                }
            });
    }

    private mapVariablesToDataSource(variables: any): void {
        variables.forEach((variable) => {
            const v: any = {};
            v.id = variable.id;
            v.defaultValue = variable.defaultValue;
            v.variableName = variable.name;
            const envValues: any[] = variable.environmentsValues;
            if (envValues && envValues.length > 0) {
                envValues.forEach((varEnv) => {
                    const projectEnv = this.environments.find(value => value.id === varEnv.envId);
                    if (projectEnv) {
                        v[projectEnv.camelCaseName] = varEnv.value;
                    }
                     if(projectEnv.isRMSource == true){
                        v.dryrun = varEnv.envCopyValue
                     }
                });
            }
            this.dataSource.push(v);
        });
    }

    private mapDataSourceToUserVariables(): any {
        const result: any = [];
        this.dataSource.forEach((item) => {
            if (item.id === undefined) {
                const value: any = {};
                value.name = item.variableName;
                value.defaultValue = item.defaultValue;
                value.dryrun = item.dryrun;
                value.environmentsValues = [];
                value.description = '';
                this.environments.forEach((e) => {
                    if(e.name == "Release Source"){
                        value.environmentsValues.push({ envId:e.id, value :item[e.camelCaseName],envCopyValue : item.dryrun
                        });  
                    }
                    else {
                        value.environmentsValues.push({ envId:e.id, value :item[e.camelCaseName]});
                    }
                });
                result.push(value);
            }else {
                this.userVariables.map((value) => {
                    if (value.id === item.id) {
                        value.name = item.variableName;
                        //value.envCopyValue = item.dryrun;
                        value.defaultValue = item.defaultValue;
                        value.environmentsValues = value.environmentsValues ? value.environmentsValues : [];
                        this.environments.forEach((e) => {
                            e.envCopyValue = item.dryrun;
                            const ee =  value.environmentsValues.find(v => v.envId === e.id);
                            if (ee) {
                                ee.value = item[e.camelCaseName];
                                ee.envCopyValue = item.dryrun;
                            }else {
                                value.environmentsValues.push({ envId:e.id, value :item[e.camelCaseName],envCopyValue:item.dryrun });
                            }
                        });
                    }
                });
            }
        });
        this.userVariables = [...this.userVariables, ...result];
    }

    public save(): void {
        this.validate();
        if (!this.isValid) {
            return;
        }
        this.mapDataSourceToUserVariables();
        this.store.dispatch({
            type: projectActions.SET_PROJECT_VARIABLES,
            payload: { projectId: this.projectId, variables: this.userVariables }
        })
            .then((res: any) => {
                if (res.status === 200) {
                    const data = (res.data) ? res.data : [];
                    this.userVariables = data;
                    this.tmpUserVariables = cloneDeep(this.userVariables);
                    this.dataSource = [];
                    this.mapVariablesToDataSource(data);
                    this.tmpDataSource = cloneDeep(this.dataSource);
                    this.dialogManagerService.showSuccessDialog({ title: '', text: '' });
                } else {
                    this.userVariables = cloneDeep(this.tmpUserVariables);
                    this.dialogManagerService.showErrorDialog({
                        title: this.translations['ERROR'],
                        text: this.translations['UNEXPECTED_ERROR']
                    });
                }
            });
    }

    public cancel(): void {
        this.dataSource = cloneDeep(this.tmpDataSource);
    }

    public addNewRow(row): void {
        this.dataSource.push(row);
    }

    public removeRow(element: any): void {
        if (element.id) {
            const currentVariable = this.userVariables.find(variable => element.id === variable.id);
            this.userVariables.splice(this.userVariables.indexOf(currentVariable), 1);
            this.tmpUserVariables.splice(this.tmpUserVariables.indexOf(currentVariable), 1);
        }
        this.dataSource.splice(this.dataSource.indexOf(element), 1);
    }

    private isFieldEmpty(value: any) {
        return !value || value.toString().trim().length === 0;
    }

    private validate() {
        this.isValid = true;
        this.validationSave = [];
        const keys =  this.environments.map((env) => this.stringFormatPipe.transformStr(env.name));
        this.dataSource.forEach((data) => {
            if (this.isFieldEmpty(data.variableName)) {
                this.validationSave.push('Variable Name is required');
                this.isValid = false;
            }
            const emptyFields = keys.filter(key => this.isFieldEmpty(data[key]));
            if (this.isFieldEmpty(data.defaultValue) && emptyFields.length > 0) {
                this.validationSave.push(`Default Value or ${this.envsName} required`);
                this.isValid = false;
            }
        });
        this.validationSave = this.validationSave.filter((v, i, a) => a.indexOf(v) === i);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/variables/variables.component.ts